(() => {
  const dialog = document.querySelector('[data-eco-sms-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const message = dialog.querySelector('textarea');
  const status = dialog.querySelector('[data-sms-status]');
  const qr = dialog.querySelector('[data-sms-qr]');
  const open = dialog.querySelector('[data-sms-open]');
  let origin, expiry, revision = 0;
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href^="sms:"]');
    if (!link || dialog.contains(link) || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || !matchMedia('(min-width: 900px) and (pointer: fine)').matches) return;
    const target = new URL(link.href);
    if (target.pathname.replace(/\s/g, '') !== '+61489272648') return;
    // Let the appointment browser reject stale selections before opening this handoff.
    const checked = link.dataset.checkedAt;
    if (checked && Date.now() - Number(checked) > 60000) return;
    event.preventDefault();
    document.querySelector('[data-eco-native-cart] cart-drawer-component')?.close?.();
    origin = link;
    clearTimeout(expiry);
    const current = ++revision;
    message.value = target.searchParams.get('body') || 'Hi Emery, I have a question for the Embod team.';
    target.search = '?body=' + encodeURIComponent(message.value);
    open.href = target.href;
    open.dataset.service = link.dataset.service || '';
    status.textContent = '';
    qr.replaceChildren();
    dialog.showModal();
    if (checked) expiry = setTimeout(() => { revision++; qr.replaceChildren(); open.removeAttribute('href'); status.textContent = 'Please select your time again so we can check availability.'; }, Math.max(0, 60000 - (Date.now() - Number(checked))));
    try {
      const { QRCode } = await import(dialog.dataset.qrModule);
      if (current !== revision || !dialog.open) return;
      new QRCode(qr, { text: target.href, width: 184, height: 184, useSVG: true });
    } catch {
      if (current === revision) status.textContent = 'Copy the message and text 0489 272 648.';
    }
  }, true);
  open.addEventListener('click', event => {
    if (origin?.dataset.checkedAt && Date.now() - Number(origin.dataset.checkedAt) > 60000) {
      event.preventDefault(); dialog.close(); origin.click();
    }
  });
  dialog.querySelector('[data-sms-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { revision++; clearTimeout(expiry); qr.replaceChildren(); origin?.focus(); });
  dialog.querySelector('[data-sms-copy]').addEventListener('click', async () => {
    if (origin?.dataset.checkedAt && Date.now() - Number(origin.dataset.checkedAt) > 60000) { status.textContent = 'Please select your time again so we can check availability.'; return; }
    try { await navigator.clipboard.writeText(message.value); status.textContent = 'Message copied. Text it to 0489 272 648.'; }
    catch { message.focus(); message.select(); status.textContent = 'Select and copy the message, then text 0489 272 648.'; }
  });
})();
